import React from 'react';

const DashboardHeader = ({ userName }) => {
  return (
    <div className="bg-white">
      <div className="px-4 py-4">
        <h1 className="text-2xl font-semibold text-gray-900">
          ¡Bienvenido {userName || 'Usuario'}!
        </h1>
      </div>
    </div>
  );
};

export default DashboardHeader;
